// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/UpgradePage/SET_INITIAL_VALUES';

// ================ Reducer ================ //

const initialState = {
  triggerReason: null,
  recommendedTier: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...state, ...payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: initialValues,
});

// ================ Thunks ================ //

export const loadData = params => (dispatch, getState, sdk) => {
  // Set any initial values from URL params if needed
  const { triggerReason, recommendedTier } = params || {};
  
  if (triggerReason || recommendedTier) {
    dispatch(setInitialValues({ triggerReason, recommendedTier }));
  }
  
  return Promise.resolve();
};